"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Object which contains meta info from response.
 */
var Meta = /** @class */ (function () {
    function Meta() {
    }
    Meta.prototype.getStatus = function () {
        return this._status;
    };
    Meta.prototype.setStatus = function (value) {
        this._status = value;
    };
    Meta.prototype.getTotalRowCount = function () {
        return this._totalRowCount;
    };
    Meta.prototype.setTotalRowCount = function (value) {
        this._totalRowCount = value;
    };
    Meta.prototype.getValidations = function () {
        return this._validations;
    };
    Meta.prototype.setValidations = function (validationErrors) {
        this._validations = validationErrors;
    };
    Meta.prototype.setValidationErrors = function (validationErrors) {
        this._validationErrors = validationErrors;
    };
    Meta.prototype.getValidationErrors = function () {
        return this._validationErrors;
    };
    Meta.prototype.getPermissionWarnings = function () {
        return this._permissionWarnings;
    };
    Meta.prototype.setPermissionWarnings = function (value) {
        this._permissionWarnings = value;
    };
    return Meta;
}());
exports.Meta = Meta;
//# sourceMappingURL=meta.model.js.map